import "./AssessMyMethod.module.css";
import Header from "@/reusable_sections/Header";
import AssessmentDisclaimer from "./sections/AssessmentDisclaimer";
import Assessment from "./sections/Assessment";
import Footer from "@/reusable_sections/Footer";
export default function AssessMyMethodPage() {
  return <div>
      <Header />
      <AssessmentDisclaimer />
      <Assessment />
      <Footer />
    </div>;
}